import React from 'react';
export function Footer() {
  return <footer className="border-t border-white/10 py-12 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-174">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-175">
        <div className="text-center md:text-left" data-id="element-176">
          <a href="#" className="text-2xl font-bold tracking-tight block mb-2" style={{
          fontFamily: "'Space Grotesk', sans-serif"
        }} data-id="element-177">
            <span className="text-white" data-id="element-178">ai</span>
            <span className="text-[#c9a84c]" data-id="element-179">.</span>
            <span className="text-white" data-id="element-180">web</span>
          </a>
          <p className="text-white/40 text-sm" data-id="element-181">
            © 2025 aiwebsitepackage.com. All rights reserved.
          </p>
        </div>

        <div className="flex space-x-6 text-sm text-white/40" data-id="element-182">
          <a href="#" className="hover:text-[#c9a84c] transition-colors" data-id="element-183">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-[#c9a84c] transition-colors" data-id="element-184">
            Terms of Service
          </a>
        </div>

        <div className="text-center md:text-right" data-id="element-185">
          <p className="text-white/40 text-sm flex items-center gap-1" data-id="element-186">
            Made with <span className="text-red-500" data-id="element-187">♥</span> for Dublin
            businesses
          </p>
        </div>
      </div>
    </footer>;
}